import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import CustomInput from './CustomInput';

const CustomNumberInputDayCount = ({ value, maxDays, onBlur, onChange, ...props }) => {
  const [inputValue, setInputValue] = useState(value);
  const [timer, setTimer] = useState(null);

  const handleChange = (e) => {
    const newValue = e.target.value;
    const reg = /^-?\d*$/; 

    if ((reg.test(newValue) && Number(newValue) <= maxDays) || newValue === '' || newValue === '-') {
      setInputValue(newValue);

      if (timer) {
        clearTimeout(timer);
      }

      const newTimer = setTimeout(() => {
        if (reg.test(newValue) && !isNaN(parseInt(newValue, 10)) && Number(newValue) <= maxDays) {
          onChange(newValue);
        } else {
          onChange('');
        }
      }, 400); 

      setTimer(newTimer);
    }
  };

  const handleBlur = () => {
    const reg = /^-?\d*$/;
    let finalValue = '';

    if (reg.test(inputValue) && !isNaN(parseInt(inputValue, 10)) && Number(inputValue) <= maxDays) {
      finalValue = parseInt(inputValue, 10).toString();
    }

    onBlur(finalValue);
  };

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  return (
    <CustomInput
      {...props}
      value={inputValue}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
};

CustomNumberInputDayCount.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  maxDays: PropTypes.number.isRequired, 
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
};

CustomNumberInputDayCount.defaultProps = {
  value: '',
  onBlur: () => {},
  onChange: () => {},
};

export default CustomNumberInputDayCount;
